import { render, staticRenderFns } from "./VehicleIntake.vue?vue&type=template&id=a5ed7e06&scoped=true"
import script from "./VehicleIntake.vue?vue&type=script&lang=js"
export * from "./VehicleIntake.vue?vue&type=script&lang=js"
import style0 from "./VehicleIntake.vue?vue&type=style&index=0&id=a5ed7e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ed7e06",
  null
  
)

export default component.exports